export const ENCRYPTION_LEVEL = 256;

export default {
  ENCRYPTION_LEVEL,
};
